import { GenericTreeNode } from '../components/generic-tree/generic-tree-node';
import { DocumentViewerContext } from './dr-document';
import { ObjectActionSet } from './permission';
import { Project } from './project';
import { WorkingSet } from './working-set';
import { WorkBasketContext } from './task';
import { StatusManagementContext } from './job';
import { User } from './user';

export class ExternalAppData {
    sessionToken: string;
    currentProject: Project;
    userPermissions: Array<ObjectActionSet>;
    // temp
    debugServerIp: string;
    projectDataHandle: string;
    broadcastChannelName: string;
    isTPAuthEnabledSystem: boolean;

    constructor(value: Partial<ExternalAppData>) {
        Object.assign(this, value);
    }
}

export class ExternalWorkbasketData extends ExternalAppData {
    static readonly appName = 'workbasket';
    static readonly cacheName = 'workbasketExternalAppData';

    workBasketContext: WorkBasketContext;

    constructor(value: Partial<ExternalWorkbasketData>) {
        super(value);
        Object.assign(this, value);
    }
}

export class ExternalDocumentViewerData extends ExternalAppData {
    static readonly appName = 'document-viewer';
    static readonly cacheName = 'documentViewerExternalAppData';

    documentViewerContext: DocumentViewerContext;
    selectedNavigationNode: GenericTreeNode;
    currentClusterView: GenericTreeNode;
    projectData: WorkingSet;

    constructor(value: Partial<ExternalDocumentViewerData>) {
        super(value);
        Object.assign(this, value);
    }
}

export class ExternalStatusManagementData extends ExternalAppData {
    static readonly appName = 'status-management';
    static readonly cacheName = 'statusManagementExternalAppData';
    statusManagementContext: StatusManagementContext;
    appContext: any;
    currentUser: User;

    constructor(value: Partial<ExternalStatusManagementData>) {
        super(value);
        Object.assign(this, value);
    }
}

export class ExternalRRPromotionTracker extends ExternalAppData{
    static readonly appName = 'reef-review-promotion-tracking';
    static readonly cacheName = 'rrPromotionTrackerExternalAppData';

    constructor(value: Partial<ExternalRRPromotionTracker>) {
        super(value);
        Object.assign(this, value);
    }
}